import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useSearchInput } from 'hooks/useSearchInput';

export const GET_ACCOUNT_PURCHASES = gql`
  query GetAccountPurchases($input: AccountPurchasesInput!) {
    getAccountPurchases(input: $input) {
      count
      results {
        id
        fee
        total
        refund
        discount
        credit
        subtotal
        purchase_date
        status
        transfer_id
        charge_id
        user {
          id
          name
          first_name
          last_name
          formatted_name
          email
          cellphone
        }
        card {
          last4
        }
        international_fee
      }
    }
  }
`;

export function useGetAccountPurchases({
  accountId,
  year,
  type,
  ticketId,
  startDate,
  endDate,
}) {
  const { input } = useSearchInput();

  return useQuery(GET_ACCOUNT_PURCHASES, {
    variables: {
      input: {
        account_id: accountId,
        ...(year ? { year } : null),
        ...(type ? { type } : null),
        ...(ticketId ? { ticket_id: Number(ticketId) } : null),
        ...(startDate ? { start_date: startDate } : null),
        ...(endDate ? { end_date: endDate } : null),
        ...(input?.page ? { page: input.page } : null),
        ...(input?.queryString ? { queryString: input.queryString } : null),
      },
    },
    skip: !accountId,
  });
}
